/* istanbul ignore file */
export * from './CarrierDeliveryInfo';
